import FooterControl from '@/components/FooterControl.vue';
import { GENDER_OPTOINS, ORDER_TYPE_OPTION } from '@/config/constant';
import { BigNumber } from 'bignumber.js';
import payDialog from '../pay/index.vue';

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });

export default {
  name: 'sale-drug',
  components: { FooterControl, payDialog },
  data() {
    return {
      tableData: [],
      patient: {
        patientName: '--',
        genderStr: '--',
        age: '-',
        ageType: '-',
      },
      orderType: '',
      fee: {},
      records: [],
      salePrescription: [], // 直接售药
      wPrescription: [], // 西药处方
      ePrescription: [], // 中药处方
      infusionPrescription: [], // 输液卡处方
      applyPrescription: [], // 贴敷
      inquiryInfo: {}, // 病例
      orderBalance: {
        alipayAmt: 0, // 支付宝支付
        cashAmt: 0, // 现金
        commercialInsurance: 0, // 商业保险支付
        medicalInsurance: 0, // 医保支付
        otherAmt: 0, // 其他支付
        posAmt: 0, // 银行卡支付
        remainingAmt: 0, // 余额支付
        wechatAmt: 0, // 微信支付
        wechatAppsAmt: 0, // 微信小程序支付
        wechatPayAmt: 0, // 微信当面付
        debtAmt: 0, // 欠费
        refundAmt: 0, // 欠费抵扣
        memberAmt: 0,// 会员支付
      }, // 订单结算方式
      orderExamList: [], // 检查项
      orderAdditionList: [], // 附加费用
      dialogVisible: false,
      orderIds: '',
      serverTotal: '',
      payType: 'onePay',
      debtorInfo: {},
      recordVersion: '', // 订单版本
      settlementObj: {}, // 结算流程
      prohibitFlag: false, // 是否禁止结算
    };
  },

  methods: {
    getFeeDetail() {
      const { id } = this.$route.query;
      this.orderIds = id;
      this.$api.feeDispense.completedDetail({ id }).then((res) => {
        // console.log(res,'res==');
        this.recordVersion = res.recordVersion;
        if (res.patient.patientId) {
          this.patient = res.patient;
          this.patient.genderStr = GENDER_OPTOINS.find(it => this.patient.gender === it.value).label;
        }
        this.orderAdditionList = res.orderAdditionList;
        // console.log(res);
        this.orderType = ORDER_TYPE_OPTION.find(it => res.orderType == it.value).label;
        this.fee = res;
        this.serverTotal = res.actualReceivableAmt;
        this.inquiryInfo = res.inquiryInfo;
        this.records = res.records;
        // 直接售药
        this.salePrescription = res.orderPrescriptionList.filter(item => item.type === 5);
        this.wPrescription = res.orderPrescriptionList.filter(item => item.type === 1);
        this.ePrescription = res.orderPrescriptionList.filter(item => item.type === 2);
        this.infusionPrescription = res.orderPrescriptionList.filter(item => item.type === 6);
        this.applyPrescription = res.orderPrescriptionList.filter(item => item.type === 7);
        this.orderExamList = res.orderExamList;
        this.getBalance();
      });
    },
    // 获取支付方式
    getBalance() {
      const orderBalanceList = Object.keys(this.orderBalance);
      this.records.forEach((record) => {
        // 如果是退费就减掉付款方式上的金额
        const def = record.operateType === 2 ? 'minus' : 'plus';
        orderBalanceList.forEach((balance) => {
          const recordBalanceItem = record.recordBalance.find(it => it.payModesLabel === balance);
          if (recordBalanceItem) {
            this.orderBalance[balance] = BN(this.orderBalance[balance])[def](recordBalanceItem.amt).toFixed(2);
          }
        });
      });
    },
    totalPrice(count, price) {
      return BN(price).multipliedBy(count).toFixed(2);
    },
    // 饮片处方数量
    eNum(gramCount, saleUnit, dosage) {
      if (dosage === 1) {
        return gramCount + saleUnit;
      }
      return `${gramCount}${saleUnit}*${dosage}`;
    },
    confirm() {
      this.dialogVisible = true;
      this.$refs.payDialog.changeActiveName()
    },
    goBack() {
      this.$router.go(-1);
    },
    complate() {
      this.dialogVisible = false;
      // this.$store.commit('changeRouterInfo', this.orderIds);
      this.goBack();
    },
    recordsFavorable(item) {
      return BN(item.couponDiscountAmt)
        .plus(item.discountAmt)
        .plus(item.wipeAmt)
        .toFixed(2);
    },
    dialogClose() {
      this.getFeeDetail();
    },
    totalPriceSticker(count, gramCount, price) {
      return BN(price).multipliedBy(count).multipliedBy(gramCount).toFixed(2);
    },
    
  },
  filters: {
    typeStr(value) {
      if (value === 1) return '收费';
      if (value === 2) return '退费';
      if (value === 3) return '还款';
      return '';
    },
    staff(value) {
      if (value === 1) return '收费';
      if (value === 2) return '退费';
      if (value === 3) return '收费';
      return '';
    },
    typeString(value) {
      if (value === 1) return '应收';
      if (value === 2) return '实退';
      if (value === 3) return '实收';
      return '';
    },
    
  },
  computed: {
    favorable() {
      return BN(this.fee.couponDiscountAmt)
        .plus(this.fee.discountAmt)
        .plus(this.fee.wipeAmt)
        .toFixed(2);
    },
    // 欠费数据整理
    debtAmtCmpt() {
      const orderBalanceList = Object.keys(this.orderBalance);
      let result = 0;
      // 所有欠费金额之和
      this.records.forEach((record) => {
        const recordBalanceItem = record.recordBalance.find(it => it.payModesLabel === 'debtAmt');
        if (recordBalanceItem) {
          result = BN(result).plus(recordBalanceItem.amt).toFixed(2);
        }
      });
      // 其他订单之和
      this.records.forEach((record) => {
        if (record.operateType === 3) {
          orderBalanceList.forEach((balance) => {
            const recordBalanceItem = record.recordBalance.find(it => it.payModesLabel === balance);
            if (recordBalanceItem) {
              result = BN(result).minus(recordBalanceItem.amt).toFixed(2);
            }
          });
        }
        if (record.operateType === 2) {
          const recordBalanceItem = record.recordBalance.find(it => it.payModesLabel === 'refundAmt');
          if (recordBalanceItem) {
            result = BN(result).minus(recordBalanceItem.amt).toFixed(2);
          }
        }
      });
      return result;
    },
    isHiSuccess() {
      return this.$store.state.global.isHiSuccess
    }
  },
  mounted() {
    this.getFeeDetail();
  },
};
